"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variants = exports.StyledAttribute = exports.Definition = exports.Term = exports.Attributes = exports.Heading = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "ProductOverviewPane";
exports.classes = {
    brandLogo: `${PREFIX}-brandLogo`,
    variant: `${PREFIX}-variant`,
    spaced: `${PREFIX}-spaced`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "42px 20px",
    background: theme.colours.white,
    border: `1px solid ${theme.colours.alabaster}`,
    fontSize: "1rem",
    [`.${exports.classes.brandLogo}`]: {
        fill: theme.colours.white,
        height: "50px",
        marginBottom: "20px"
    },
    [`.${exports.classes.variant}`]: {
        display: "inline-block",
        margin: "2px"
    }
}));
exports.Heading = (0, styles_1.styled)(typography_1.default)({
    marginBottom: "32px"
});
exports.Attributes = (0, styles_1.styled)("ul")(({ theme }) => ({
    margin: 0,
    padding: 0,
    listStyleType: "none"
}));
exports.Term = (0, styles_1.styled)("span")({
    display: "inline-block",
    fontWeight: "500",
    "&::after": {
        content: "':'",
        display: "inline-block",
        marginRight: "6px"
    }
});
exports.Definition = (0, styles_1.styled)("span")(({ theme }) => ({
    color: theme.colours.slate
}));
exports.StyledAttribute = (0, styles_1.styled)("li")(({ theme }) => ({
    borderBottom: `solid 1px ${theme.colours.storm}`,
    fontFamily: "Effra Medium",
    padding: "20px 0",
    "&:first-of-type": {
        paddingTop: 0
    },
    "&:last-child": {
        borderBottom: "none",
        paddingBottom: 0
    }
}));
exports.Variants = (0, styles_1.styled)("div")({
    display: "block",
    margin: "-2px",
    marginTop: "12px",
    paddingLeft: "5px",
    [`&.${exports.classes.spaced}`]: {
        margin: "-10px",
        marginTop: "7px",
        [`.${exports.classes.variant}`]: {
            margin: 0
        }
    }
});
//# sourceMappingURL=data:application/json;base64,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